<template>
  <div
    class="loading-container flex h-full max-h-full cursor-progress items-center justify-center text-gray-600"
  >
    <div
      class="flex flex-row items-center rounded-sm bg-white/75 p-3 dark:bg-slate-700/75 dark:text-gray-300"
      :class="size === 'small' ? '' : 'gap-5'"
    >
      <div
        class="relative"
        :class="size === 'small' ? 'h-10 w-10' : 'h-16 w-16'"
      >
        <span
          class="absolute flex items-center justify-center"
          :class="size === 'small' ? 'h-10 w-10' : 'h-16 w-16'"
        >
          <FontAwesomeIcon
            :icon="['fal', 'spinner-third']"
            fixed-width
            spin
            :size="size === 'small' ? '2x' : '4x'"
          />
        </span>
        <div
          class="absolute flex items-center justify-center text-primary-500"
          :class="size === 'small' ? 'h-10 w-10' : 'h-16 w-16'"
        >
          <CremaLogo :class="size === 'small' ? 'h-4 w-4' : 'h-8 w-8'" />
        </div>
      </div>
      <span
        v-if="displayLabel"
        class="font-bold capitalize-first"
        :class="size === 'small' ? 'text-lg' : 'text-3xl'"
      >
        {{ label ?? $t('global.loading') }}
      </span>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import CremaLogo from '@c/layouts/main-layout/CremaLogo.vue'

/** Funeral Manager's loading placeholder, with Crema's flame. */
export default {
  name: 'LoadingComponent',
  components: { CremaLogo, FontAwesomeIcon },
  props: {
    displayLabel: { type: Boolean, default: true },
    label: { type: String, required: false, default: null },
    size: { type: String, required: false, default: null }
  }
}
</script>

<style>
.loading-container {
  user-select: none;
}
</style>
